/**
 * Leaf constants for the Society triple-points takeover.
 * Kept out of societyTriplePointsTakeoverConfig so campaign components can read dates
 * without the config ↔ components cycle.
 */
export const triplePointCampaignId = 'triple_points_july_2026'
export const triplePointsTakeoverId = 'societytriplepoints'
export const triplePointsEndDate = '2026-07-31' // No business rules, only display
export const triplePointsRoute = '/triple-points'
